import { createFileRoute } from "@tanstack/react-router";

import { parseMapSearch } from "@/features/map";
import { MapPage } from "@/features/map/pages";
import { strictSearch } from "@/shared/lib/search";

/** The map belongs to the orders section (model book, chapter 24): its guard is the section's. */
export const Route = createFileRoute("/_app/orders/map")({
  validateSearch: strictSearch(parseMapSearch),
  component: Map,
});

function Map() {
  const search = Route.useSearch();
  const navigate = Route.useNavigate();
  return (
    <MapPage
      search={search}
      onSearchChange={(next) => void navigate({ search: next, replace: true })}
    />
  );
}
